
































































import { Prop, Component, Mixins, Watch } from 'vue-property-decorator';
import { Autocomplete, Button, FormItem, Option, Select } from 'element-ui';
import CollapseCard from '@/components/layout/CollapseCard.vue';
import GmapAutocomplete from 'vue2-google-maps/src/components/autocomplete.vue';
import PortSelect from '@/components/inputs/PortSelect2.vue';
// Types
import {
  fetchQuotes_inquiries_quotes_inquiry,
  PlaceFields,
  TransportationTypeEnum,
  InquiryFields,
  AddressInput,
  fetchQuotes_inquiries_quotes
} from '@/types/graphql/schemaTypes';
import { ElAutocomplete, RouteInput, SelectOption } from '@/types/types';
import { i18n } from '@/plugins/i18n';
import FromTo from '@/mixins/fromTo';
import get from 'lodash/get';

@Component({
  components: {
    CollapseCard,
    GmapAutocomplete,
    PortSelect,
    'el-autocomplete': Autocomplete,
    'el-button': Button,
    'el-form-item': FormItem,
    'el-option': Option,
    'el-select': Select
  }
})
export default class Route extends Mixins(FromTo) {
  @Prop({ required: true, type: Object }) private inquiry!: fetchQuotes_inquiries_quotes_inquiry;
  @Prop() private quote?: fetchQuotes_inquiries_quotes;
  @Prop({ required: true, type: String })
    private transportationMode!: ('seaLCL' | 'seaFCL' | 'air' | null);

  private arrivalAddressSearch = '';
  private departureAddressSearch = '';
  private inquiryInput: RouteInput = {
    arrivalAddress: null,
    arrivalPlaceId: null,
    departureAddress: null,
    departurePlaceId: null
  };

  private arrivalAddress(inquiry: fetchQuotes_inquiries_quotes_inquiry) {
    if (inquiry.arrivalCustomerLocation) {
      return inquiry.arrivalCustomerLocation.fullAddress;
    }

    if (inquiry.arrivalAddress) {
      return inquiry.arrivalAddress!.formattedAddress;
    }
    return null;
  }

  private departureAddress(inquiry: fetchQuotes_inquiries_quotes_inquiry) {
    if (inquiry.departureCustomerLocation) {
      return inquiry.departureCustomerLocation.fullAddress;
    }

    if (inquiry.departureAddress) {
      return inquiry.departureAddress!.formattedAddress;
    }
    return null;
  }

  private convertToAddress(googleData: any): AddressInput {
    return {
      name: googleData.name,
      addressComponents: JSON.stringify(googleData.address_components),
      formattedAddress: googleData.formatted_address,
      placeId: googleData.place_id,
      latitude: parseFloat(googleData.geometry.location.lat()),
      longitude: parseFloat(googleData.geometry.location.lng()),
      url: googleData.url
    };
  }

  public setDepartureAddress(googleData: any) {
    this.inquiryInput.departureAddress = this.convertToAddress(googleData);
    this.emitInputs(this.inquiryInput);
  }

  public setArrivalAddress(googleData: any) {
    this.inquiryInput.arrivalAddress = this.convertToAddress(googleData);
    this.emitInputs(this.inquiryInput);
  }

  get portSearchType(): TransportationTypeEnum {
    switch (this.transportationMode) {
      case 'seaLCL':
      case 'seaFCL':
        return TransportationTypeEnum.sea;
      case 'air':
        return TransportationTypeEnum.air;
      default:
        return TransportationTypeEnum.any;
    }
  }

  @Watch('inquiry', { deep: true, immediate: true })
  private setInputs(inquiry: fetchQuotes_inquiries_quotes_inquiry) {
    this.inquiryInput = {
      arrivalPlaceId: get(inquiry, 'arrivalPlace.id') || null,
      departurePlaceId: get(inquiry, 'departurePlace.id') || null
    };

    if (this.quote) {
      this.arrivalAddressSearch = get(this.quote, 'inquiry.arrivalAddress.formattedAddress');
      this.inquiryInput.arrivalAddress = get(this.quote, 'inquiry.arrivalAddress');
      this.departureAddressSearch = get(this.quote, 'inquiry.departureAddress.formattedAddress');
      this.inquiryInput.departureAddress = get(this.quote, 'inquiry.departureAddress');
    }
  }

  @Watch('inquiryInput', { deep: true })
  private emitInputs(inquiryInput: RouteInput) {
    this.$emit('update', inquiryInput);
  }
}
